var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls},_vm._l((_vm.stateTree),function(item,i){return _c('tree-node',{key:i,attrs:{"show-checkbox":_vm.showCheckbox,"multiple":_vm.multiple,"is-check":item.isCheck,"data":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }